<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="ApplicationName">
          <a-input placeholder="Please enterApplicationName" v-decorator="[ 'appName', validatorRules.appName]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Tenant ID">
          <a-input placeholder="Please enter tenant ID" v-decorator="[ 'appSsid', validatorRules.appSsid]"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Package Name">
          <a-input placeholder="Please enter package name" v-decorator="[ 'appPackageName', validatorRules.appPackageName]"/>
        </a-form-item>

        <!-- Image upload component -->
        <div class="btn_select" @click="selectLoadImg">
          <div>
            <input type="file" name="file" accept="image/*" @change="changeImage()" ref="avatarInput">
          </div>
        </div>
        <button type="submit" class="btn_submit" @click="upLoad">Upload Image</button>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="logo">
          <a-input placeholder="Please enterlogo" v-decorator="[ 'logoUrl',validatorRules.logoUrl]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="APPDownloadAddress">
          <a-input placeholder="Please enterAPPDownloadAddress" v-decorator="[ 'appDownUrl',validatorRules.appDownUrl]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Collection Type">
          <dict-select
              v-decorator="[ 'collectorType']"
              :dict-code="DICT_CODE.COLLECTOR_TYPE"
              :placeholder="$t('select')"
            />
        </a-form-item>

         <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="showUrl">
          <a-input placeholder="Please entershowUrl" v-decorator="[ 'showUrl']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="APP Version">
          <a-input placeholder="Please enter APP version" v-decorator="[ 'appVersion']"/>
        </a-form-item>

        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="Update Tip Language">
          <a-input placeholder="Please enter update tip language" v-decorator="[ 'promptMsg']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Push Recommended">
          <a-input placeholder="Please enter push recommended" v-decorator="[ 'vipProductViewFlag']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Customer Service Phone">
          <a-input placeholder="Please enter customer service phone" v-decorator="[ 'appMobile']"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="AppSchame">
          <a-input placeholder="Please enterAppSchame" v-decorator="[ 'appSchame']"/>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
import pick from 'lodash/pick'
import { addApp, editApp,uploadImage } from '@/webpublicapi/system'
import DictSelect from '../../modules/DictSelect';


// duplicateCheck
export default {
  name: 'AppModal',
  components: {
    DictSelect,
  },
  mounted(){

    if(typeof FileReader=='undifined')        {
      console.log('Sorry, your browser does not support FileReader');
    }else{
      console.log('FileReader');
    }
  },
  data () {
    return {
      value: 1,
      title: 'Action',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        appName: { rules: [{ required: true, message: 'Please enterApplicationName!' }] },
        appSsid: { rules: [{ required: true, message: 'Please enter tenant ID!' }] },
        appPackageName: { rules: [{ required: true, message: 'Please enter package name!' }] },
        logoUrl: { rules: [{ required: true, message: 'Please enterlogoUrl!' }] },
        appDownUrl: { rules: [{ required: true, message: 'Please enterAPPDownloadAddress!' }] },
      }
    }
  },
  created () {
  },
  methods: {
    add () {
      this.edit({})
    },
    edit (record) {
      if (record.id) {
        this.visiblekey = true
      } else {
        this.visiblekey = false
      }
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'appName', 'appSsid', 'appPackageName', 'logoUrl', 'collectorType', 'showUrl','appVersion','promptMsg','appDownUrl',
        'vipProductViewFlag','appMobile','appSchame'))
      })
    },
    // Confirm
    handleOk () {
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          let obj
          console.log(formData)
          if (!this.model.id) {
            obj = addApp(formData)
          } else {
             obj = editApp(formData)
          }
          obj.then((res) => {
            if (res.code === 1000) {
              this.$message.success(res.msg)
              this.$emit('ok')
            } else {
              this.$message.warning(res.msg)
            }
          }).finally(() => {
            this.confirmLoading = false
            this.close()
          })
        }
      })
    },
    // Close
    handleCancel () {
      this.close()
    },

    close () {
      this.$emit('close')
      this.visible = false
    },
    selectLoadImg() {
      this.$refs.avatarInput.dispatchEvent(new MouseEvent("click"));
    },
    changeImage() {
      let files = this.$refs.avatarInput.files;
      let that = this;
      function readAndPreview(file) {
        that.file = file
        if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
          let reader = new FileReader();
          reader.onload = function() {
            if (that.imgData !== this.result) {
              that.imgData = this.result // This isbase64Data format
            }
          };
          reader.readAsDataURL(file);
        }
      }

      if (files) {
        [].forEach.call(files, readAndPreview);
      }
    },
    upLoad() {
      let imgFile = this.file;//Get uploaded image
      let formData = new FormData();//PassformdataUpload
      formData.append('file', imgFile)
      this.axios({
        method: "post",
        url: "/web/app/upload",
        data: formData,
        core: true
      })
        .then((res) => {
          console.log(res.data);
          alert("UploadSuccess! AddressIs:"+res.data)
          this.form.setFieldsValue({
            logoUrl: res.data
          })
        })
        .catch((error) => {
          console.log(error);
        })

    },
  }
}
</script>
